import fetch from "@/uilts/request";

export default {
    async open(data) {
        return await fetch.post("EbikeNotary/open", data)
    },
    async submit(data) {
        return await fetch.post("EbikeNotary/submit", data)
    },
    async status(data) {
        return await fetch.post("EbikeNotary/status", data)
    },
    async getDetail(data) {
        return await fetch.post("EbikeNotary/getDetail", data)
    },
    async getSignH5(data) {
        return await fetch.post("EbikeNotary/getSignH5", data)
    },
    async downloadNotary(data) {
        return await fetch.post("EbikeNotary/downloadNotary", data)
    },
}
